import { z } from 'zod';

// Tax number validation schema
const taxNumberSchema = z
    .string()
    .min(1, 'Tax number is required')
    .regex(/^\d{2}-\d{7}$/, 'Enter a valid tax number (e.g., 12-3456789)');
// Bank account number validation schema
const bankAccountNumberSchema = z
    .string()
    .min(1, 'Bank account number is required')
    .regex(/^\d{10,19}$/, 'Enter a valid bank account number');
// Bank routing number validation schema
const bankRoutingNumberSchema = z
    .string()
    .min(1, 'Bank routing number is required')
    .regex(/^\d{9}$/, 'Enter a valid bank routing number');

export { bankAccountNumberSchema, bankRoutingNumberSchema, taxNumberSchema };
//# sourceMappingURL=financial.js.map
